'use client';

import { PostHogProvider } from '@monorepo/common';
import { Provider } from 'jotai';
import type { Session } from 'next-auth';
import { SessionProvider, useSession } from 'next-auth/react';

export const JotaiProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => <Provider>{children}</Provider>;

/**
 * session を渡さないとブラウザが自力で /api/auth/session を取得し、失敗するとゲストで固定される（GF-2374）。
 * 渡せば初回レンダーから確定値になり、その取得自体が省略される。
 */
export const AuthProvider = ({
  children,
  session,
}: {
  children: React.ReactNode;
  session: Session | null;
}) => <SessionProvider session={session}>{children}</SessionProvider>;

/**
 * PostHog Provider をアプリ側の next-auth セッションに接続する。
 *
 * 各ログイン経路を個別に修正せず、セッションを単一の真実として顧客ID（distinctId）を渡し、
 * identify / reset の切り替えは共通 Provider 側に委譲する。
 * `useSession` を使うため AuthProvider（SessionProvider）の内側に配置すること。
 */
export const AnalyticsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { data: session } = useSession();
  // 顧客IDは数値型のため、PostHog の distinctId（文字列）に合わせて変換する。
  const distinctId = session?.user?.id != null ? String(session.user.id) : null;
  return <PostHogProvider distinctId={distinctId}>{children}</PostHogProvider>;
};
